import React, { useState, useEffect } from "react";
import { headTestReports, testReportsUrlFor } from "../../../services/api/testReports.api";
import { useSnackbar } from "notistack";
import { showSnack } from "../../../utils/component";
import { MessageCard } from "../../MessageCard";
import OpenInNew from "@material-ui/icons/OpenInNew";

export interface TestReportPreviewProps {
	// full name of the report to render
	report: string;
}

/**
 * displays test reports embedded in an iframe
 */
export const TestReportPreview = ({ report }: TestReportPreviewProps) => {
	const { enqueueSnackbar } = useSnackbar();
	const [message, setMessage] = useState<string | null>(null);
	const [reportUrl, setReportUrl] = useState<string | null>(null);

	useEffect(() => {
		const selectReport = async (report) => {
			try {
				setReportUrl(null);
				setMessage(null);
				await headTestReports(report)();
				setReportUrl(testReportsUrlFor(report));
			} catch (e) {
				console.log(e);
				const msg = `Could not get ${report}`;
				showSnack(enqueueSnackbar, msg, "error");
				setMessage(msg);
			}
		};

		selectReport(report);
	}, [enqueueSnackbar, report]);

	return (
		<div>
			<div>{message && <MessageCard textAlign="left" padding={0} message={message} />}</div>
			<div>
				{reportUrl && !message && (
					<div>
						<a href={reportUrl} target="_blank" rel="noopener noreferrer">
							Open report in new tab <OpenInNew fontSize="inherit" />
						</a>
						<iframe style={{ width: "100%", height: 700, marginTop: 8 }} src={reportUrl} />
					</div>
				)}
			</div>
		</div>
	);
};
